import React from "react";
import createSvgIcon from "@material-ui/core/utils/createSvgIcon";

/**
 * author: Michael Irigoyen
 * id F1415D50-592B-4480-94D6-1FA82CDBA7B9
 * name skip-previous-outline
 * version: 3.8.95
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/skip-previous-outline.svg
 * tags
 */
export const SkipPreviousOutlineIcon = createSvgIcon(<><path d="M6,6H8V18H6M9.5,12L18,18V6M16,14.14L12.97,12L16,9.86V14.14Z" /></>, 'SkipPreviousOutlineIcon');
export default SkipPreviousOutlineIcon